module.exports = __webpack_public_path__ + "static/Cardealerships-0fa51c0a9aa4960be4894cd2ed8a9111.svg";